import axios from '@/axios'
import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		fiscalYears: []
	},

	actions: {
		fetchAll({ commit }) {
			return axios.get('/financialFile').then(data => {
				commit(types.STORE_FISCAL_YEARS, data);
				return data;
			})
		},

		create({ commit }, { name, startDate, endDate }) {
			return axios.post('/financialFile', {
				companyName: name,
				startDate,
				endDate,
				yearName: startDate.slice(0, 4),
				companyLogoFile: '',
				isActive: false,
				isArchived: false
			})
		},

		update({ commit }, { id, name, startDate, endDate }) {
			return axios.put(`/financialFile/${id}`, {
				companyName: name,
				startDate,
				endDate,
				yearName: startDate.slice(0, 4),
				companyLogoFile: '',
				isActive: false,
				isArchived: false
			})
		},

		updateActiveState({ commit }, { id }) {
			return axios.put(`/financialFile/${id}/active`)
		},

		delete({ commit }, { id }) {
			return axios.delete(`/financialFile/${id}`);
		},
	},

	mutations: {
		[types.STORE_FISCAL_YEARS](state, fiscalYears) {
			state.fiscalYears = fiscalYears;
		}
	},

	getters: {
		getFiscalYearById: state => id => state.fiscalYears.find(c => c.id === id)
	}
}